export default {
  text: {
    default: 'Bestelle direkt über uns für den schnellsten Service, kostenlose Rewards und hilf uns Gebühren zu sparen',
    promo_code: {
      title: 'Wir danken dir, dass du über unsere Seite bestellst',
      description_one: '🔥 {{discount}} Rabatt - Code:',
      description_other: '🔥 {{discount}} Rabatt auf {{count}} Bestellungen - Code:',
    },
    copied_promo_code: 'Promo Code in die Zwischenablage kopiert',
  },
};
